import { type FC, useState } from "react";
import { Card, CardContent, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  useMarketingComponents,
  useMarketingLimits,
} from "@/partner/entities/marketing";
import type { BroadcastFormState } from "../model/broadcastForm";

interface BroadcastMainCardProps {
  form: BroadcastFormState;
  onChange: (patch: Partial<BroadcastFormState>) => void;
  disabled: boolean;
}

/** Название рассылки и письмо из библиотеки (поиск по названию). */
export const BroadcastMainCard: FC<BroadcastMainCardProps> = ({
  form,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();
  const [nameTouched, setNameTouched] = useState(false);
  const { EmailTemplatePicker } = useMarketingComponents();
  // Длину названия ограничиваем, когда пределы пришли; до этого её
  // проверит бэкенд при сохранении.
  const limits = useMarketingLimits();

  return (
    <Card elevation={0}>
      <CardContent>
        <Stack spacing={2}>
          <TextField
            label={t("broadcasts.form.name")}
            value={form.name}
            onChange={(event) => onChange({ name: event.target.value })}
            onBlur={() => setNameTouched(true)}
            error={nameTouched && !form.name.trim()}
            helperText={
              nameTouched && !form.name.trim()
                ? t("broadcasts.form.errors.name")
                : t("broadcasts.form.nameHint")
            }
            disabled={disabled}
            slotProps={{
              htmlInput: { maxLength: limits?.broadcastNameLength },
            }}
            fullWidth
          />
          <EmailTemplatePicker
            value={form.emailTemplateId}
            onChange={(emailTemplateId) => onChange({ emailTemplateId })}
            disabled={disabled}
            label={t("broadcasts.form.email")}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
